/**
 * Separators people add (or leave out) without meaning to change the value:
 * spaces, hyphens, underscores, dots and slashes.
 */
const SEPARATORS = /[\s\-_./]+/g

/** Lowercase and drop separators, keeping letters (including æøå) and digits. */
function squash(value: string): string {
  return value.toLowerCase().replace(SEPARATORS, '')
}

/**
 * Whether a combobox item's searchable text matches what the user typed.
 *
 * Matching runs twice: once on the text as-is, then again with separators
 * removed on both sides. The second pass is what lets a registration number
 * stored space-free ("XV73963") be found by typing it the way it is printed
 * ("XV 73963") — without it, the item disappeared as soon as the user typed
 * the space in the middle of the plate.
 */
export function comboboxItemMatchesQuery(
  searchableText: string,
  query: string
): boolean {
  const trimmedQuery = query.trim().toLowerCase()
  if (!trimmedQuery) return true

  if (searchableText.toLowerCase().includes(trimmedQuery)) return true

  const squashedQuery = squash(query)
  if (!squashedQuery) return true

  return squash(searchableText).includes(squashedQuery)
}

/**
 * Whether an item already carries the name the user typed, ignoring case and
 * surrounding whitespace -- the same rule the backend applies to unique names.
 */
export function comboboxItemNamedExactly(
  itemName: string,
  query: string
): boolean {
  const trimmedQuery = query.trim().toLowerCase()
  return trimmedQuery !== '' && itemName.trim().toLowerCase() === trimmedQuery
}
